import { useEffect } from "react";

import { fetchToken } from "../../bridges/BridgeServices";

const { openBot } = require("./ChatbotUtil");

import ChatBotMeta from "../../utils/singletonChatBotMeta";

export const useChatbotSdk = () => {
  useEffect(() => {
    (function (d, w, c) {
      if (!d.getElementById("spd-busns-spt")) {
        var n = d.getElementsByTagName("script")[0],
          s = d.createElement("script");
        var loaded = false;
        s.id = "spd-busns-spt";
        s.async = "async";
        s.setAttribute("data-self-init", "false");
        s.setAttribute("data-init-type", "opt");
        s.src =
          "https://cdn.in-freshbots.ai/assets/share/js/freshbots.min.js";
        s.setAttribute(
          "data-client",
          "7a8a65f57e385750707ee31773de0a0a5a62e2af"
        );
        s.setAttribute(
          "data-bot-hash",
          "6213cec9917be9d198cc531a342c8ad344807372"
        );
        s.setAttribute("data-env", "prod");
        s.setAttribute("data-region", "in");

        if (c) {
          s.onreadystatechange = s.onload = function () {
            if (!loaded) {
              c();
            }
            loaded = true;
          };
        }
        n.parentNode.insertBefore(s, n);
      }
    })(document, window, function () {
      /**
       * @desc    Initiate Freshbots widget by implementing the hooks which they have provided.
       *          As soon as the freshbot widget is initiated it calls the getSessionData hook for the token.
       *          Service.fetchToken is called before initiating the freshbot widget so that the token is generated before calling the widget.
       *          In case the token is not yet generated, we try to initiate bot every 50 msecond after checking the condition of presence of token.
       *          The function doesn't initiate the bot if the token is not generated within 1 minutes.
       */

      var boundary = 60000; // In mseconds
      var interval = 100; // In mseconds
      var endTime = new Date().getTime() + boundary;

      fetchToken();
      (function p() {
        if (Number(new Date()) < endTime) {
          if (window.token) {
            var clonedToken = JSON.parse(
              JSON.stringify(window.token)
            );

            window.Freshbots.initiateWidget(
              {
                getSessionData: function () {
                  const newObj = Object.create(clonedToken);
                  newObj["cstmr::eml"] =
                    clonedToken.userId +
                    "@iris.phonepe.com";
                  newObj["cstmr::nm"] = clonedToken.name;
                  return newObj;
                },
                getClientParams: function () {
                  return ChatBotMeta.get();
                },
                autoInitChat: true,

                navigateToApp: function () {
                  // Service.navigateTo(Util.constants.txnHistory)
                },
                navigateToURL: function (ctaKey) {
                  // if (ctaKey) Service.navigateToURL(ctaKey)
                },
                openURL: function (URL) {
                  // if (URL) Service.openURL(URL)
                },
              },
              function (successResponse) {
                if (
                  document.getElementsByClassName(
                    "loading-bot"
                  )?.[0]
                ) {
                  document
                    .getElementsByClassName(
                      "contact-support-content"
                    )[0]
                    .classList.remove("loading-bot");
                }

                if (
                  document.getElementsByClassName(
                    "contact-support-btn"
                  )?.[0]
                ) {
                  document
                    .getElementsByClassName(
                      "desktop-contact-support-btn"
                    )[0]
                    .classList.remove(
                      "contact-support-btn"
                    );
                }

                if (
                  typeof window !== "undefined" &&
                  window.location.hash.split("?")[0] ===
                    "#openbot"
                ) {
                  openBot();
                }
              },
              function (errorResponse) {}
            );
            return;
          }
          setTimeout(p, interval);
        }
      })();
    });
  }, []);
};
